import styled, { css } from 'styled-components';

export const Container = styled.li`
  padding: 1.8rem 2.3rem;

  position: relative;
  width: 100%;
  height: fit-content;
  background: #ffffff;
  border-radius: 0.4rem;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const FirstSectionContainer = styled.section`
  display: flex;
  justify-content: space-between;
`;

type WrapperProps = {
  secondary?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  ${(props) =>
    props.secondary &&
    css`
      padding: 1.7rem 0 0.5rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export const LineWrapper = styled.div`
  display: flex;
  margin-bottom: 0.6rem;
`;

export const Label = styled.span`
  font-weight: bold;
  margin-right: 0.4rem;
`;

type StatusContainerProps = {
  status: string;
};

export const StatusContainer = styled.div<StatusContainerProps>`
  width: 100%;
  height: 4.4rem;
  border-radius: 50px;
  opacity: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.status === 'Ativo' &&
    css`
      background: #04c230;
    `}

  ${(props) =>
    props.status === 'Inativo' &&
    css`
      background: #d90606;
    `}

    @media (max-width: 425px) {
    margin: 0 1rem;
  }
`;

export const StatusLabel = styled.span`
  color: #fff;
  font-size: 1.9rem;
`;

export const Status = styled.p``;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
`;
